export const ADD_FORMS_LABELS = {
  HEADING: 'Add Forms',
  DESCRIPTION: 'Select one or more forms to add to this plan',
  CANCEL: 'Cancel',
  ADD: 'Add',
  EMPTY: 'No active forms available.',
};

/** `medium` keeps the shared Modal box content-height instead of stretching to 75vh. */
export const ADD_FORMS_MODAL_TYPE = { type: 'normal', status: 'info', size: 'medium' };
